import { writable } from 'svelte/store';

let BankStore = writable({
    empty: true
});

export default BankStore;
